module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-sm-9 col-xs-12\"> <div> <div id=\"api_mode_toggle\" class=\"filter-selector\"></div> <div id=\"insurance_daterange_pickers\" class=\"filter-selector\"></div> </div> <div id=\"insurance_search\"></div> </div> </div> <div id=\"insurance_list\"></div> <div id=\"insurance_pagination\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/insurances/template.ejs
// module id = 805
// module chunks = 1